import { computed, defineComponent, inject, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { currentOrderProviderKey } from "../../../infrastructure/current_order_provider";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  setup() {
    // Injections
    const { t } = useI18n();
    const currentOrderProvider = inject(currentOrderProviderKey);
    const orderService = inject(orderServiceKey);
    const priceFormatter = inject(priceFormatterKey);

    // variables and computed
    const tenantContext = computed(
      () => currentOrderProvider?.currentOrder?.value?.tenant_context ?? null,
    );
    const billingTypeOrder = ["email", "post"];
    const billingTypeChoices = computed(() =>
      [...(tenantContext.value?.billing_type_choices ?? [])].sort(
        (a, b) => billingTypeOrder.indexOf(a) - billingTypeOrder.indexOf(b),
      ),
    );
    const billingTypePostCostFormatted = computed(() =>
      priceFormatter?.formatPrice(
        tenantContext.value?.billing_type_post_cost ?? 0,
        { currency: false },
      ) ?? "",
    );

    const billingType = ref<string | null>(null);
    // Der aktuell gewählte billing_type wird vom Backend nicht in der Order zurückgegeben,
    // daher wird beim ersten Laden des tenant_context auf den Default initialisiert.
    let initialized = false;
    watch(
      tenantContext,
      (tc) => {
        if (!initialized && null != tc) {
          billingType.value = tc.billing_type_default;
          initialized = true;
        }
      },
      { immediate: true },
    );

    // methods
    const billingTypeChange = async () => {
      await orderService?.orderUpdate(billingType.value, null, null);
    };

    return {
      t,
      billingType,
      billingTypeChoices,
      billingTypePostCostFormatted,
      billingTypeChange,
    };
  },
} as any);
